<script setup lang="ts">
import { TabsRoot, useForwardPropsEmits, type TabsRootEmits, type TabsRootProps } from "reka-ui";
import { useDelegatedProps, type ClassProps } from "../../lib/base-props";

interface Props extends ClassProps, TabsRootProps {}

const props = defineProps<Props>();
const emit = defineEmits<TabsRootEmits>();

const delegatedProps = useDelegatedProps(props);

const forwarded = useForwardPropsEmits(delegatedProps, emit);
</script>

<template>
	<TabsRoot :class="props.class" v-bind="forwarded">
		<slot />
	</TabsRoot>
</template>
